"use client";

import * as React from "react";
import styled from "styled-components";

import { SVGIcon } from "../SVGIcon";

type Direction = "up" | "down" | "left" | "right";

export interface IProps extends SVGIcon.IProps {
  direction: Direction;
}

const DirectionalIcon = styled(SVGIcon)<{ direction: Direction }>`
  transform: rotateZ(
    ${({ direction }) => {
      switch (direction) {
        case "right":
          return "90deg";
        case "down":
          return "180deg";
        case "left":
          return "270deg";
        case "up":
        default:
          return "0deg";
      }
    }}
  );
`;

export const DoubleChevron = React.memo(({ direction, ref, ...props }: IProps & React.RefAttributes<SVGElement>) => {
  return (
    <DirectionalIcon
        direction={direction}
        viewBox="0 0 24 24"
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          d="M23.1445 12.9258L12.6017 2.40007C12.5247 2.31807 12.4318 2.25272 12.3286 2.20805C12.2254 2.16337 12.1141 2.14032 12.0017 2.14032C11.8892 2.14032 11.778 2.16337 11.6748 2.20805C11.5716 2.25272 11.4786 2.31807 11.4017 2.40007L0.858817 12.9258"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1445 21.8574L12.6017 11.3146C12.4414 11.1575 12.226 11.0695 12.0017 11.0695C11.7773 11.0695 11.5619 11.1575 11.4017 11.3146L0.858817 21.8574"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </DirectionalIcon>
  );
});
